/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

const useCapacityRangeError = ({
	formHandler: {
		form, errors
	}
}) => {
	const { minCapacity, maxCapacity } = form.value;
	useEffect(() => {
		if (!maxCapacity || !minCapacity) {
			errors.change("capacityRange", false);
			return;
		}
		errors.change("capacityRange", hasCapacityRangeError());
	}, [minCapacity, maxCapacity]);
	function hasCapacityRangeError() {
		return Number(maxCapacity) < Number(minCapacity);
	}
}

export default useCapacityRangeError;